// COPYRIGHT © 2019 Esri
//
// All rights reserved under the copyright laws of the United States
// and applicable international laws, treaties, and conventions.
//
// This material is licensed for use under the Esri Master License
// Agreement (MLA), and is bound by the terms of that agreement.
// You may redistribute and use this code without modification,
// provided you adhere to the terms of the MLA and include this
// copyright notice.
//
// See use restrictions at http://www.esri.com/legal/pdfs/mla_e204_e300/english
//
// For additional information, contact:
// Environmental Systems Research Institute, Inc.
// Attn: Contracts and Legal Services Department
// 380 New York Street
// Redlands, California, USA 92373
// USA
//
// email: contracts@esri.com
//
// See http://js.arcgis.com/next/esri/copyright.txt for details.

define({lblItem:"sisu",title:"Logi sisse",info:"Logige sisse, et saada ligipääs {resource} sisule {server} serveris",oAuthInfo:"Logige sisse {server}-isse.",lblUser:"Kasutajanimi:",lblPwd:"Parool:",lblOk:"OK",lblSigning:"Login sisse...",lblCancel:"Tühista",errorMsg:"Vale kasutajanimi/parool. Palun proovige uuesti.",invalidUser:"Teie sisestatud kasutajanimi või parool on vale.",forbidden:"Kasutajanimi ja parool on õiged, kuid Teil puudub ligipääs sellele ressursile.",noAuthService:"Autentimise teenusele ligipääs ebaõnnestus"});